export default __webpack_public_path__ + "static/media/Grant Wilkie Resume.9ce9f47a.pdf";